// Polyfill Object.hasOwn for older browsers (Chrome < 93, Edge < 93)
if (typeof (Object as any).hasOwn !== 'function') {
  (Object as any).hasOwn = (obj: object, prop: PropertyKey) => Object.prototype.hasOwnProperty.call(obj, prop);
}

export {};
